import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './RacingThemeSearchPriceRange.module.css';

/**
 * Search filter price range inputs.
 */
const RacingThemeSearchPriceRange = props => {
  const { minValue = '', maxValue = '', onChange, onCommit } = props;
  const [minDraft, setMinDraft] = useState(minValue);
  const [maxDraft, setMaxDraft] = useState(maxValue);

  useEffect(() => {
    setMinDraft(minValue);
  }, [minValue]);

  useEffect(() => {
    setMaxDraft(maxValue);
  }, [maxValue]);

  const commit = (nextMin, nextMax) => {
    if (typeof onCommit === 'function') {
      onCommit({ min: nextMin, max: nextMax });
    }
  };

  return (
    <div className={styles.priceRangeInputs}>
      <input
        className={styles.priceInput}
        type="number"
        placeholder="Min $"
        value={minDraft}
        readOnly={typeof onCommit !== 'function'}
        onChange={event => {
          const next = event.target.value;
          setMinDraft(next);
          if (typeof onChange === 'function') {
            onChange({ min: next, max: maxDraft });
          }
        }}
        onBlur={() => commit(minDraft, maxDraft)}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            commit(minDraft, maxDraft);
          }
        }}
      />
      <input
        className={styles.priceInput}
        type="number"
        placeholder="Max $"
        value={maxDraft}
        readOnly={typeof onCommit !== 'function'}
        onChange={event => {
          const next = event.target.value;
          setMaxDraft(next);
          if (typeof onChange === 'function') {
            onChange({ min: minDraft, max: next });
          }
        }}
        onBlur={() => commit(minDraft, maxDraft)}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            commit(minDraft, maxDraft);
          }
        }}
      />
    </div>
  );
};

RacingThemeSearchPriceRange.propTypes = {
  minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onCommit: PropTypes.func,
};

export default RacingThemeSearchPriceRange;
